export default __webpack_public_path__ + "static/assets/fbc5f43326a7f2d16305ca726987ab20.svg";